module.exports = __webpack_public_path__ + "media/images/icon/payment/amex-card-49ca1b68f70388a5574456659799c465.svg";